import React from 'react';
import PropTypes from 'prop-types';
import s from './Braverman.css';
class Braverman extends React.Component {
  static propTypes = {
    braverman: PropTypes.arrayOf(
      PropTypes.shape({
        question: PropTypes.string.isRequired,
        neuroType: PropTypes.string.isRequired,
        testType: PropTypes.string,
      }),
    ).isRequired,
  };
  shuffleArray= (array)=> {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array
  }
  updateCount = (inc,value) => {
      let update = {}
      var qp = value.question in this.state
      if ( (!qp && inc>0) || (qp && inc!=this.state[value.question])) {
          update['neuro'] = this.state.neuro
          update['neuro'][value.neuroType] = this.state.neuro[value.neuroType] + inc
          update[value.question]=inc
          this.setState(update)
      }
      update[value.question]=inc
      this.setState(update)
  }
  state={neuro:{'D':0,'S':0,'A':0,'G':0}}
  neuroTrans={'D':'Dopamine','S':'Serotonin','A':'Acetylcholine','G':'GABA'}
  qmap= this.shuffleArray(this.props.data.slice());
 render() {
     let qs=null;
     function doMouse(qs,style)
     {
         console.log(qs,style)
     }
     var aStyle={padding:"5px",margin:"5px"}
      var tableStyle={border:"1px solid",padding:"10px"}
      var push={backgroundColor: 'lightblue'}
      var noPush={backgrounColor: 'green'}
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1>Braverman Deficiency Test</h1>
           <form style={aStyle}>
                <table style={tableStyle}>
          {this.qmap.map(item => (
              <tr style={tableStyle}>
                  <td style={tableStyle}>
              <span style={this.state[item.question] ? push : aStyle} >
                {item.question}
              </span>
                  </td>
                  <td>
                      <button name={item.question} value="Y"  style={this.state[item.question] ==1 ? push : noPush } onClick={(event)=>{event.preventDefault();this.updateCount(1,item)}}>Y</button>
                  </td>
                  <td>
                      <button name={item.question} value="N" style={this.state[item.question] ==-1 ? push : noPush} onClick={(event)=>{event.preventDefault();this.updateCount(-1,item)}} >N</button>
                  </td>
              </tr>
          ))}
                </table>
            </form>
            <span>            <p>Deficiency Scores</p>
                {Object.keys(this.state.neuro).map((k)=> <div style={aStyle}>{this.neuroTrans[k]} - {this.state.neuro[k]}</div>)}
            </span>
        </div>
     </div>
    );
  }
}

export default Braverman;



// WEBPACK FOOTER //
// ./src/Braverman.js